import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {RosterService} from '../../shared/roster.service';
import {GradeConfirmationData} from '../../shared/interface/submit-grade-confirmation.interfaces';
import {GradeType} from '../../shared/enum/grade-type';


@Component({
    selector: 'app-roster-submit-confirmation',
    templateUrl: './submit-confirmation.component.html',
    styleUrls: ['./submit-confirmation.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class SubmitConfirmationComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<SubmitConfirmationComponent>,
        public rosterService: RosterService,
        @Inject(MAT_DIALOG_DATA) public data: GradeConfirmationData
    ) {
    }

    readonly gradeType: GradeType = GradeType.getInstance();

    continueOrSubmitText: string = 'Continue';
    showSubmitButton: boolean = false;

    //local variables that is needed
    ngOnInit(): void {
        console.log(this.data);
        this.setNextDisplay();
    }

    setNextDisplay() {
        //determine who to show first

        if (
            this.data.gradeGDConfirmation.numberOfStudent > 0 &&
            this.data.gradeGDConfirmation.needToConfirm &&
            !this.data.gradeGDConfirmation.isConfirm
        ) {
            this.data.gradeGDConfirmation.hideConfirm = false;
            this.showSubmitButton = false;
            return;
        }
        if (
            this.data.gradeIConfirmation.numberOfStudent > 0 &&
            this.data.gradeIConfirmation.needToConfirm &&
            !this.data.gradeIConfirmation.isConfirm
        ) {
            this.data.gradeIConfirmation.hideConfirm = false;
            this.showSubmitButton = false;
            return;
        }
        if (
            this.data.gradeChangeConfirmation.numberOfStudent > 0 &&
            this.data.gradeChangeConfirmation.needToConfirm &&
            !this.data.gradeChangeConfirmation.isConfirm
        ) {
            this.data.gradeChangeConfirmation.hideConfirm = false;
            this.showSubmitButton = false;
            return;
        }

        //reach this point nothing to show close diaglog and submit
        this.onClose();

    }

    onClose() {
        this.dialogRef.close(this.data);
    }

    onCancelClick() {
        this.dialogRef.close();
    }

    onSubmitClick() {

        if (
            this.data.gradeGDConfirmation.needToConfirm &&
            !this.data.gradeGDConfirmation.hideConfirm
        ) {
            this.data.gradeGDConfirmation.isConfirm = true;
            this.data.gradeGDConfirmation.hideConfirm = true;
            this.setNextDisplay();
            return;

        }
        if (
            this.data.gradeIConfirmation.needToConfirm &&
            !this.data.gradeIConfirmation.hideConfirm
        ) {
            this.data.gradeIConfirmation.isConfirm = true;
            this.data.gradeIConfirmation.hideConfirm = true;
            this.setNextDisplay();
            return;
        }
        if (
            this.data.gradeChangeConfirmation.needToConfirm &&
            !this.data.gradeChangeConfirmation.hideConfirm
        ) {
            this.data.gradeChangeConfirmation.isConfirm = true;
            this.data.gradeChangeConfirmation.hideConfirm = true;
            this.setNextDisplay();
            return;
        }


    }

    ngOnChanges() {
        if (
            this.data.gradeGDConfirmation.needToConfirm &&
            this.data.gradeGDConfirmation.isConfirm &&
            !this.data.gradeGDConfirmation.hideConfirm
        ) {
            this.showSubmitButton = true;
            return;
        }
        if (
            this.data.gradeIConfirmation.needToConfirm &&
            this.data.gradeIConfirmation.isConfirm &&
            !this.data.gradeIConfirmation.hideConfirm
        ) {
            this.showSubmitButton = true;
            return;
        }
        if (
            this.data.gradeChangeConfirmation.needToConfirm &&
            this.data.gradeChangeConfirmation.isConfirm &&
            !this.data.gradeChangeConfirmation.hideConfirm
        ) {
            this.showSubmitButton = true;
            return;
        }
    }

    canSubmit() {
        //find number of need to not confirm but need to confirm and have student

        if (
            this.data.gradeGDConfirmation.needToConfirm &&
            this.data.gradeGDConfirmation.isConfirm &&
            !this.data.gradeGDConfirmation.hideConfirm
        ) {
            return true;
        }
        if (
            this.data.gradeIConfirmation.needToConfirm &&
            this.data.gradeIConfirmation.isConfirm &&
            !this.data.gradeIConfirmation.hideConfirm
        ) {
            return true;
        }
        if (
            this.data.gradeChangeConfirmation.needToConfirm &&
            this.data.gradeChangeConfirmation.isConfirm &&
            !this.data.gradeChangeConfirmation.hideConfirm
        ) {
            return true;
        }
        return false;


    }
}
